<template>
  <!-- pc -->
  <div class="animatepage" id="animatepage">
    <div class="overlay" id="overlay"></div>
    <!-- <div class="overlay" id="overlay2"></div> -->
    <div class="background1" id="background1">
      <img src="/assets/~/media/images/activity/film2505-prod/pc/cbg.png" alt="" />
    </div>
    <!-- <div class="background2" id="background2">
      <img src="/assets/~/media/images/activity/film2505-prod/pc/dbg.png" alt="" />
    </div> -->
    <div class="coverimg1" id="coverimg1">
      <img src="/assets/~/media/images/activity/film2505-prod/pc/cpic.png" alt="" />
    </div>
    <!-- <div class="coverimg2" id="coverimg2">
      <img class="bg-1" src="/assets/~/media/images/activity/film2505-prod/pc/juzhao/01a.png" alt="">
      <img class="bg-2" src="/assets/~/media/images/activity/film2505-prod/pc/juzhao/02a.png" alt="">
      <img class="bg-3" src="/assets/~/media/images/activity/film2505-prod/pc/juzhao/03a.png" alt="">
      <img class="bg-4" src="/assets/~/media/images/activity/film2505-prod/pc/juzhao/04a.png" alt="">
      <img v-for="(pic, index) in picImages" :key="index" code-stm="`event, PAGEURL, 剧照_查看`"
      :class="[`pic-${index+1}`, 'pic']" :src="pic.src" alt="" @click="showPop(pic.src)">
    </div> -->
    <div class="coverimg3" id="coverimg3">
      <img src="/assets/~/media/images/activity/film2505-prod/pc/epic.png" alt="">
    </div>
    <div class="logo-box">
          <img src="/assets/~/media/images/activity/film2505-prod/pc/page-2-logo.png" alt=""/>
    </div>
    <div class="logo-box2" id="logo2">
      <img src="/assets/~/media/images/activity/film2505-prod/pc/page-2-logo.png" alt=""/>
    </div>
    <!-- <div class="logo-box3" id="logo3">
      <img src="/assets/~/media/images/activity/film2505-prod/pc/page-2-logo.png" alt=""/>
    </div> -->
    <!-- 弹窗 -->
    
    <div id="" class="pop-overlay" v-if="isShowPop"></div><!-- 遮罩层 -->
    <div id="" class="pop-img" v-if="isShowPop">
      <img :src="popimgSrc" alt="">
    </div>
    <img class="pop-close" @click="hideCover" code-stm="`event, PAGEURL, 剧照弹窗_关闭`"
    v-if="isShowPop" src="/assets/~/media/images/activity/film2505-prod/pc/juzhao/close.png" alt="">

  </div>
</template>

<script>
import { isPortraitFun, isPc, isWeiXin, isAndroid } from "@/utils/utils.js";
export default {
  data() {
    return {
      isPortrait: isPortraitFun(),
      videoVisible: false,
      isWxAndroid: false,
      popimgSrc: "",

      showIcon: true,
      showFullVideo: false,
      preText: "https://www.kia.cn",
      //视频资源
      fullVideoUrlPc:
        "https://img.kia.cn/content/videos/aowang2025video/page2pc.mp4",
      fullVideoUrlMob:
        "https://img.kia.cn/content/videos/aowang2025video/page2mob.mp4",
      //预览视频预览图片
      videoPosterPc:
        "/assets/~/media/images/activity/aowangAnimate/twopage-videocover-pc.jpg",
      videoPosterMob:
        "/assets/~/media/images/activity/aowangAnimate/twopage-videocover-mob.jpg",

      isShowVideo: false,
      isShowPop: false,

      textShowPc1: false,
      textShowPc2: false,
      textShowMob1: false,
      textShowMob2: false,
      
      // 图片数组
      picImages: [
        { src: "/assets/~/media/images/activity/film2505-prod/pc/juzhao/01.png" },
        { src: "/assets/~/media/images/activity/film2505-prod/pc/juzhao/02.png" },
        { src: "/assets/~/media/images/activity/film2505-prod/pc/juzhao/03.png" },
        { src: "/assets/~/media/images/activity/film2505-prod/pc/juzhao/04.png" },
        { src: "/assets/~/media/images/activity/film2505-prod/pc/juzhao/05.png" },
        { src: "/assets/~/media/images/activity/film2505-prod/pc/juzhao/06.png" },
        { src: "/assets/~/media/images/activity/film2505-prod/pc/juzhao/07.png" },
        { src: "/assets/~/media/images/activity/film2505-prod/pc/juzhao/08.png" },
        { src: "/assets/~/media/images/activity/film2505-prod/pc/juzhao/09.png" },
        { src: "/assets/~/media/images/activity/film2505-prod/pc/juzhao/10.png" }
      ],
    };
  },
  components: {},
  computed: {
    isSafari() {
      var userAgent = navigator.userAgent;
      if (userAgent.indexOf("Safari") > -1) {
        return true;
      } else {
        return false;
      } //判断是否Safari浏览器
    },
    // swiper() {
    //   return this.$refs.mySwiper.swiper;
    // },
  },
  watch: {
    videoVisible(n) {
      if (!n) {
        this.close();
      }
    },
  },
  mounted() {
    if (!window.location.href.includes("https://www.kia.cn")) {
      this.preText = "https://uat.kia.cn";
    } else {
      this.preText = "https://www.kia.cn";
    }
    var that = this;
    window.addEventListener("scroll", function () {
      var scrollPosition = window.scrollY;
      var vh = window.innerHeight;
      var vw = window.innerWidth;
      var pageTop = document
        .getElementById("animatepage")
        .getBoundingClientRect().top;
      //背景
      var background1Element = document.getElementById("background1");
      var background2Element = document.getElementById("background2");
      //书的图
      var bookElement = document.getElementById("coverimg3");
      var logo3Element = document.getElementById("logo2");
      

      var overlayElement = document.getElementById("overlay");
      // var videoElement2 = document.getElementById("overlay2");
      // var videooverlay = this.document.getElementsByClassName('video-overlay')
      // var page2 = this.document.getElementsByClassName('page-2')
      // var style = page2[0].style;
      // var backdropFilter =style.backdropFilter
      // var backgroundColor = style.backgroundColor;
      // debugger

      // 计算滚动进度百分比，用于控制透明度
      var scrollProgress 
      var targetPosition = -25 * vh / 100 - (619 / 2200) * vw;
      var targetPosition2 = -25 * vh / 100 - (1238 / 2200) * vw;
      var targetPosition3  = -50 * vh / 100 - (1238 / 2200) * vw - (619 / 2200) * vw;
      var targetPosition4  = -50 * vh / 100 - (1238 / 2200) * vw - (619 / 2200) * vw - (419 / 2200) * vw;
      var targetPosition5 = -50 * vh / 100 - (1238 / 2200) * vw - (1238 / 2200) * vw - (419 / 2200) * vw;
      if(pageTop > 0){
        //遮罩跟随，隐藏背景1
        overlayElement.style.display = "block";
        overlayElement.style.position = "absolute";
        

        background1Element.style.display = "none";
      }
      else if (pageTop <= 0 && pageTop > -vh / 4 ) {
        overlayElement.style.display = "block";
        overlayElement.style.position = "fixed";
        // 第一阶段：从1减小到0
        scrollProgress = 1 - Math.abs(pageTop) / (vh / 8);
        //固定背景1，显示背景1
        background1Element.style.position = "fixed";
        background1Element.style.top = "78px";
        background1Element.style.bottom = "auto";
        background1Element.style.display = "block";

        background1Element.style.transform =  1 ;
        //隐藏图片3
        bookElement.style.display = "none";
        logo3Element.style.display = "none";
      } else if (pageTop <= -vh / 4 && pageTop > targetPosition) {
        overlayElement.style.display = "block";
        overlayElement.style.position = "fixed";
        //显示背景1
        background1Element.style.display = "block";
        background1Element.style.position = "fixed";
        // 第二阶段：从0增加到1
        var totalDistance = Math.abs(targetPosition + vh / 4);
        var currentDistance = Math.abs(pageTop + vh / 4);
        scrollProgress = currentDistance / totalDistance;
        // 背景1的缩放
        var scale = that.calculateScale(scrollProgress)
        background1Element.style.transform = `scale(${scale}) `;
        //隐藏图片3
        bookElement.style.display = "none";
        logo3Element.style.display = "none";
      } else if (pageTop <= targetPosition && pageTop > targetPosition2) {
        console.log("3333");
        overlayElement.style.display = "block";
        overlayElement.style.position = "fixed";
        //背景2开始了
        //隐藏背景1
        background1Element.style.display = "none";
        // 第三阶段：从1减小到0
        var totalDistance = Math.abs(targetPosition2 - targetPosition);
        var currentDistance = Math.abs(pageTop - targetPosition);
        scrollProgress = 1 - currentDistance / totalDistance;

        bookElement.style.display = "block";
        logo3Element.style.display = "block";
      }
      else{
        overlayElement.style.position = "absolute";
        overlayElement.style.display = "none";
      }
      // 应用计算出的透明度值
      overlayElement.style.opacity = scrollProgress;
      background1Element.style.opacity = 1 - scrollProgress;
    });
    //原
    // window.addEventListener("scroll", function () {
    //   var scrollPosition = window.scrollY;
    //   var vh = window.innerHeight;
    //   var vw = window.innerWidth;
    //   var pageTop = document
    //     .getElementById("animatepage")
    //     .getBoundingClientRect().top;
    //   //背景
    //   var background1Element = document.getElementById("background1");
    //   var background2Element = document.getElementById("background2");
    //   //书的图
    //   var bookElement = document.getElementById("coverimg3");
    //   var logo3Element = document.getElementById("logo3");
      

    //   var overlayElement = document.getElementById("overlay");
    //   // var videoElement2 = document.getElementById("overlay2");
    //   // var videooverlay = this.document.getElementsByClassName('video-overlay')
    //   // var page2 = this.document.getElementsByClassName('page-2')
    //   // var style = page2[0].style;
    //   // var backdropFilter =style.backdropFilter
    //   // var backgroundColor = style.backgroundColor;
    //   // debugger

    //   // 计算滚动进度百分比，用于控制透明度
    //   var scrollProgress 
    //   var targetPosition = -50 * vh / 100 - (619 / 2200) * vw;
    //   var targetPosition2 = -50 * vh / 100 - (1238 / 2200) * vw;
    //   var targetPosition3  = -50 * vh / 100 - (1238 / 2200) * vw - (619 / 2200) * vw;
    //   var targetPosition4  = -50 * vh / 100 - (1238 / 2200) * vw - (619 / 2200) * vw - (419 / 2200) * vw;
    //   var targetPosition5 = -50 * vh / 100 - (1238 / 2200) * vw - (1238 / 2200) * vw - (419 / 2200) * vw;
    //   if(pageTop > 0){
    //     // if(backdropFilter){
    //     //   overlayElement.style.backdropFilter = backdropFilter;
    //     // }
    //     // if(backgroundColor){
    //     //   overlayElement.style.backgroundColor = backgroundColor;
    //     // }
    //     // videoElement2.style.display = "block";
    //     // videoElement2.style.backgroundColor = videooverlay[0].style.backgroundColor;
        
    //     //遮罩跟随，隐藏背景1
    //     overlayElement.style.display = "block";
    //     overlayElement.style.position = "absolute";

    //     background1Element.style.display = "none";
    //   }
    //   else if (pageTop <= 0 && pageTop > -vh / 2) {
    //     overlayElement.style.display = "block";
    //     overlayElement.style.position = "fixed";
    //     // 第一阶段：从1减小到0
    //     scrollProgress = 1 - Math.abs(pageTop) / (vh / 2);
    //     //固定背景1，显示背景1
    //     background1Element.style.position = "fixed";
    //     background1Element.style.top = "0";
    //     background1Element.style.bottom = "auto";
    //     background1Element.style.display = "block";

    //     background1Element.style.transform =  1 ;
    //   } else if (pageTop <= -vh / 2 && pageTop > targetPosition) {
    //     overlayElement.style.display = "block";
    //     overlayElement.style.position = "fixed";
    //     // overlayElement.style.background = "linear-gradient(to top right, #101415, #000)";
    //     //隐藏背景2
    //     background2Element.style.display = "none";
    //     //显示背景1
    //     background1Element.style.display = "block";
    //     background1Element.style.position = "fixed";
    //     // 第二阶段：从0增加到1
    //     var totalDistance = Math.abs(targetPosition + vh / 2);
    //     var currentDistance = Math.abs(pageTop + vh / 2);
    //     scrollProgress = currentDistance / totalDistance;
    //     // 背景1的缩放
    //     // var scale =  (1 * (1 - scrollProgress) + 0.1); 
    //     var scale = that.calculateScale(scrollProgress)
    //     background1Element.style.transform = `scale(${scale}) `;
    //   } else if (pageTop <= targetPosition && pageTop > targetPosition2) {
    //     console.log("3333");
    //     overlayElement.style.display = "block";
    //     overlayElement.style.position = "fixed";
    //     // overlayElement.style.background = "linear-gradient(to top right, #212120, #000)";
    //     //背景2开始了
    //     //隐藏背景1
    //     background1Element.style.display = "none";
    //     //显示背景2 固定背景2
    //     background2Element.style.display = "block";
    //     background2Element.style.position = "fixed";
    //     background2Element.style.top = "0";
    //     background2Element.style.bottom = "auto";
    //     // 第三阶段：从1减小到0
    //     var totalDistance = Math.abs(targetPosition2 - targetPosition);
    //     var currentDistance = Math.abs(pageTop - targetPosition);
    //     scrollProgress = 1 - currentDistance / totalDistance;
    //   }
    //   else if (pageTop <= targetPosition2 && pageTop > targetPosition3 ) {
    //     overlayElement.style.display = "block";
    //     overlayElement.style.position = "fixed";
    //     //显示背景2
    //     background2Element.style.display = "block";
    //     background2Element.style.position = "fixed";
    //     // 第四阶段：从0增加到1
    //     var totalDistance = Math.abs(targetPosition3 - targetPosition2);
    //     var currentDistance = Math.abs(pageTop - targetPosition2);
    //     scrollProgress = currentDistance / totalDistance;
    //     console.log(scrollProgress);
    //     // var scale =  (1 * (1 - scrollProgress)); 
    //     var scale = that.calculateScale(scrollProgress)
    //     background2Element.style.transform = `scale(${scale}) `;

    //     //隐藏图片3
    //     bookElement.style.display = "none";
    //     logo3Element.style.display = "none";
    //   }
    //   else if (pageTop <= targetPosition3 && pageTop > targetPosition4 ) {
    //     overlayElement.style.display = "block";
    //     overlayElement.style.position = "fixed";
    //     //隐藏背景2
    //     background2Element.style.display = "none";
    //     //遮罩跟随，隐藏遮罩
    //     var totalDistance = Math.abs(targetPosition4 - targetPosition3);
    //     var currentDistance = Math.abs(pageTop - targetPosition3);
    //     scrollProgress = 1 - currentDistance / totalDistance;
    //     //隐藏图片3
    //     bookElement.style.display = "block";
    //     logo3Element.style.display = "block";
    //   }else{
    //     console.log("4444");
    //     overlayElement.style.position = "absolute";
    //     overlayElement.style.display = "none";
    //   }
    //   // 应用计算出的透明度值
    //   overlayElement.style.opacity = scrollProgress;
    //   background1Element.style.opacity = 1 - scrollProgress;
    //   // console.log("scrollProgress",scrollProgress);
    //   // overlayElement.style.background = `linear-gradient(to top right, rgba(19, 25, 28, 1), rgba(19, 25, 28, 0));`;
    //   // overlayElement.style.background = `linear-gradient(45deg, rgba(225,225,225, ${scrollProgress}) 90%, rgba(19, 25, 28, 0) 95%)`;

    //   // linear-gradient(to top right, rgba(0, 0, 0, var(--dynamic-value)), transparent);
    //   // scale(${scale})
    // });
  },
  destroyed() { },
  methods: {
    hideCover() {
      this.isShowPop = false;
    },
    showPop(src) {
      this.isShowPop = true;
      this.popimgSrc = src;
    },
    calculateScale(scrollProgress) {
  // 计算缩放比例
      let scale = 1 * (1 - scrollProgress) + 0.2;
      // 如果缩放比例小于1，则加上0.1
      if (scale < 1) {
        scale += 0.1;
      }
      // 如果最终缩放比例超过1，则将其设为1
      if (scale > 1) {
        scale = 1;
      }
      return scale;
    }
  },
};
</script>

<style lang="scss" scoped>
.animatepage {
  position: relative;
  // height: calc(50vh + (1238 / 2200) * 100vw + (1238 / 2200) * 100vw + (1230 / 2200) * 100vw);
  height: calc(25vh + (1238 / 2200) * 100vw + (1230 / 2200) * 100vw);
  width: 100%;
  user-select: none;
  // background-color: rgba(19, 25, 28);
  background-color: rgba(19, 25, 28);
  .overlay {
    display: none;
    // position: fixed;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    // background-color: #000;
    background-color: rgba(19, 25, 28);
    // background: linear-gradient(to top, #101415, rgba(29, 29, 33));
    z-index: 15;
  }

  .background1 {
    display: none;
    background-color: rgba(19, 25, 28);
    // opacity: 1;
    top: 78px;
    // transition: opacity 1s;
    position: absolute;
    width: 100%;
    height: 100vh;
    z-index: 9;
    transform-origin: right top;
    transition: transform  ease-out;
  }
  .background2 {
    display: none;
    background-color: rgba(19, 25, 28);
    // opacity: 1;
    top: 0;
    right: 0;
    // transition: opacity 1s;
    position: absolute;
    width: calc((1295 / 2200) * 100vw);
    height: calc((959 / 2200) * 100vw);
    z-index: 9;
    transform-origin: right top;
    transition: transform  ease-out;
  }

  .coverimg1 {
    position: relative;
    // left: calc(283 / 2200 * 100vw);
    // bottom:0;
    height: calc(25vh + (1238 / 2200) * 100vw);
    padding-top: calc(25vh + 224 / 2200 * 100vw);
    padding-left: calc(294 / 2200 * 100vw);
    z-index: 20;

    img {
      width: calc(1665 / 2200 * 100vw);
      height: calc(838 / 2200 * 100vw);
    }
  }

  .coverimg2 {
    position: relative;
    height: calc((1238 / 2200) * 100vw);
    z-index: 20;
    padding-bottom: calc(157 / 2200 * 100vw);
    padding-left: calc(266 / 2200 * 100vw);
    // img {
    //   margin-top: calc(236 / 2200 * 100vw);
    //   width: calc(1596 / 2200 * 100vw);
    //   height: calc(782 / 2200 * 100vw);
    // }
    img{
      position: absolute;
    }
    .pic {
      width: calc(342 / 2200 * 100vw);
      height: calc(204 / 2200 * 100vw);
      z-index: 21;
      cursor: pointer;
      transition: transform ease;
    }
    .pic:hover {
      transform: scale(1.03);
    }
    .bg-1 {
      top: calc(263 / 2200 * 100vw);
      left: calc(266 / 2200 * 100vw);
      width: calc(403 / 2200 * 100vw);
      height: calc(550 / 2200 * 100vw);
    }
    .bg-2 {
      top: calc(217 / 2200 * 100vw);
      left: calc(684 / 2200 * 100vw);
      width: calc(402 / 2200 * 100vw);
      height: calc(805 / 2200 * 100vw);
    }
    .bg-3 {
      top: calc(279 / 2200 * 100vw);
      left: calc(1103 / 2200 * 100vw);
      width: calc(402 / 2200 * 100vw);
      height: calc(805 / 2200 * 100vw);
    }
    .bg-4 {
      top: calc(433 / 2200 * 100vw);
      left: calc(1521 / 2200 * 100vw);
      width: calc(402 / 2200 * 100vw);
      height: calc(550 / 2200 * 100vw);
    }
    .pic-1 {
      top: calc(292 / 2200 * 100vw);
      left: calc(296 / 2200 * 100vw);
    }
    .pic-2 {
      top: calc(246 / 2200 * 100vw);
      left: calc(714 / 2200 * 100vw);
    }
    .pic-3 {
      top: calc(308 / 2200 * 100vw);
      left: calc(1133 / 2200 * 100vw);
    }
    .pic-4 {
      top: calc(462 / 2200 * 100vw);
      left: calc(1551 / 2200 * 100vw);
    }
    .pic-5 {
      top: calc(564 / 2200 * 100vw);
      left: calc(296 / 2200 * 100vw);
    }
    .pic-6 {
      top: calc(518 / 2200 * 100vw);
      left: calc(714 / 2200 * 100vw);
    }
    .pic-7 {
      top: calc(580 / 2200 * 100vw);
      left: calc(1133 / 2200 * 100vw);
    }
    .pic-8 {
      top: calc(734 / 2200 * 100vw);
      left: calc(1551 / 2200 * 100vw);
    }
    .pic-9 {
      top: calc(768 / 2200 * 100vw);
      left: calc(714 / 2200 * 100vw);
    }
    .pic-10 {
      top: calc(830 / 2200 * 100vw);
      left: calc(1133 / 2200 * 100vw);
    }
  }
  .coverimg3 {
    position: relative;
    height: calc((1230 / 2200) * 100vw);
    width: 100%;
    z-index: 12;

    img {
      width: 100%;
      height: 100%;
    }
  }
  
  .pop-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8); 
    z-index: 9999; 
  }
  .pop-img {
    position: fixed;
    width: calc(1053 / 2200 * 100vw);
    height: calc(715 / 2200 * 100vw);
    z-index: 10000;
    left: calc(50% - 526.5 / 2200 * 100vw);
    top: calc(50% - 357.5 / 2200 * 100vw);
    img {
      width: 100%;
      height: 100%;
    }
    /* padding: calc(216 / 3225 * 100vh) calc(225 / 3225 * 100vh) calc(72 / 3225 * 100vh) calc(225 / 3225 * 100vh); */
  }
  .pop-close {
    position: fixed;
    z-index: 10000;
    left: calc(50% + 526.5 / 2200 * 100vw);
    top: calc(50% - 357.5 / 2200 * 100vw);
    width: calc(36 / 2200 * 100vw);
    height: calc(36 / 2200 * 100vw);
  }

  .logo-box {
    z-index: 30 !important;
    position: absolute;
    left: 6vw;
    top: 25.3vh;
    z-index: 3;
    img {
      width: 139px;
      object-fit: cover;
    }
  }
  .logo-box2 {
    z-index: 12 !important;
    position: absolute;
    left: 6vw;
    top: calc(25.3vh + (1238 / 2200) * 100vw);
    z-index: 3;
    img {
      width: 139px;
      object-fit: cover;
    }
  }
  .logo-box3 {
    z-index: 12 !important;
    position: absolute;
    left: 6vw;
    top: calc(55.3vh + (1238 / 2200) * 100vw + (1238 / 2200) * 100vw);
    img {
      width: 139px;
      object-fit: cover;
    }
  }
}
</style>
